export default "__VITE_ASSET__BphQAbbS__"